import qs from 'qs';

const ALLOWED_REF = 'israel';

export const hasSpecialAccess = location => {
  const { search } = location;
  const { ref } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });
  return ref === ALLOWED_REF;
};

export const getSearch = location => {
  return hasSpecialAccess(location) ? qs.stringify({ ref: ALLOWED_REF }) : '';
};
